var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubemusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,5.72727273 C8.53636364,5.72727273 5.72727273,8.53636364 5.72727273,12 C5.72727273,15.4636364 8.53636364,18.2727273 12,18.2727273 C15.4636364,18.2727273 18.2727273,15.4636364 18.2727273,12 C18.2727273,8.53636364 15.4636364,5.72727273 12,5.72727273 Z M12,6.27272727 C15.15,6.27272727 17.7272727,8.83636364 17.7272727,12 C17.7272727,15.1636364 15.1636364,17.7272727 12,17.7272727 C8.83636364,17.7272727 6.27272727,15.1636364 6.27272727,12 C6.27272727,8.83636364 8.85,6.27272727 12,6.27272727 Z M9.81818182,8.86363636 L9.81818182,15.1363636 L15.1363636,11.8636364 L9.81818182,8.86363636 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubemusic);
export default __webpack_public_path__ + "static/media/youtubemusic.a2b915d2b315de15adb189e5a525d3b8.svg";
export { ForwardRef as ReactComponent };